export default __webpack_public_path__ + "static/media/img_09.051c6fee.png";